module.exports = __webpack_public_path__ + "img/fieldFamous.2c7319a2.png";